module.exports = __webpack_public_path__ + "img/video.e76c8776.jpg";